import type { FC } from 'react';
import { Navigate, useParams } from 'react-router';
import Form from './GoToTestForm';
import FormSkeleton from './FormSkeleton';
import { SuspenseBoundary } from 'components/common';
import { useGoToTestDetails } from '../api';

const EditGoToTestComponent: FC = () => {
  const { goToTestId } = useParams();
  const { data } = useGoToTestDetails({ params: { id: goToTestId } });

  if (!goToTestId) return <Navigate to={'/'} />;
  return <Form data={data} />;
};

const EditGoToTest: FC = () => {
  return (
    <SuspenseBoundary fallback={<FormSkeleton />}>
      <EditGoToTestComponent />
    </SuspenseBoundary>
  );
};

export default EditGoToTest;
